var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},[_c('div',{class:`progress-bar progress-bar-striped ${_vm.barColor} ${_vm.animated ? 'progress-bar-animated' : ''}`,style:(`width: ${_vm.width}`),attrs:{"role":"progressbar","aria-valuenow":_vm.width,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v(" "+_vm._s(_vm.width)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }